<template>
  <div>
    <v-container>
      <h2>Zablokuj dostęp do pól formularza</h2>
      <v-form ref="form">
        <v-select v-model="team" :items="teams" item-text="name" item-value="id" label="Team"></v-select>
        <v-select v-model="blockedFields" :items="fields" item-text="name" item-value="id" label="Pola do zablokowania"
                  multiple></v-select>
        <v-btn @click="submit()">Ok</v-btn>
      </v-form>
    </v-container>

    <v-container>
      <h2>Zablokowane pola</h2>
      <v-layout>
        <v-flex class="border-column bold-text" xs4>Teamy</v-flex>
        <v-flex class="border-column bold-text" xs6>Pola</v-flex>
        <v-flex class="border-column bold-text" xs2>Akcje</v-flex>
      </v-layout>
      <div v-for="(fieldsModels,teamId) in groupByTeamId()" :key="teamId">
        <v-layout>
          <v-flex class="border-column" xs4>{{ getTeamName(teamId) }}</v-flex>
          <v-flex class="border-column" xs6>{{ getFieldNames(fieldsModels) }}</v-flex>
          <v-flex class="border-column" xs2>
            <v-icon color="red" @click=deleteRules(teamId)>delete</v-icon>
          </v-flex>
        </v-layout>
      </div>
    </v-container>
  </div>
</template>

<script>
import Messenger from "@/plugins/Messenger"

export default {
  data() {
    return {
      schema: {},
      teams: [],
      blockedFields: [],
      fieldRules: [],
      team: null,
    }
  },
  computed: {
    fields() {
      let fields = []
      this.schema.fields.forEach(field => {
        fields.push(field)
        if (field['sub-fields'] != undefined) {
          field['sub-fields'].forEach(subField => fields.push(subField))
        }
      })
      return fields
    }
  },
  created() {
    let schema = this.$http.get('schema/' + this.$route.params.schemaId)
    let teams = this.$http.get('teams')
    let fieldRules = this.$http.get('schema/' + this.$route.params.schemaId + '/field-team-rules')


    Promise.all([schema, teams, fieldRules]).then((data) => {
      this.schema = data[0].data
      this.teams = data[1].data
      this.fieldRules = data[2].data
    }).catch(() => {
      this.$route.push({
        name: "not-found"
      })
    })
  },
  methods: {
    getTeamName(id) {
      let team = this.teams.find(team => team.id == id)
      return team ? team.name : ""
    },
    getFieldNames(fieldsRule) {
      return fieldsRule.map(fieldRule => {
        let field = this.fields.find(field => field.id == fieldRule.field_id)
        return field ? field.name : ''
      }).join(', ')
    },
    groupByTeamId() {
      return this.fieldRules.reduce((groups, item) => {
        let group = (groups[item.team_id] || [])
        group.push(item)
        groups[item.team_id] = group
        return groups
      }, {})
    },
    deleteRules(teamId) {
      this.$http.delete('schema/' + this.$route.params.schemaId + '/field-team-rules', {data: {teamId}}).then(e => {
        this.fieldRules = this.fieldRules.filter(fieldRule => fieldRule.team_id != teamId)
        Messenger.emitSuccess("Usunięto blokowanie pól")
      }).catch(() => Messenger.emitSuccess("Problem z usunięciem"))
    },
    submit() {
      if (!this.$refs.form.validate()) {
        return
      }

      let postData = {
        team_id: this.team,
        fields: this.blockedFields
      }

      this.$http.post(`schema/${this.schema.id}/field-team-rules`, postData).then(data => {
        this.fieldRules = this.fieldRules.filter(fieldRule => fieldRule.team_id != this.team)
        data.data.forEach(fieldRule => this.fieldRules.push(fieldRule))
        Messenger.emitSuccess("Zablokowano pola")
      }).catch(() => {
        Messenger.emitSuccess("Błąd! Problem z zablokowaniem pól")
      })
    },
  },
}
</script>
<style>
.border-column {
  border: 1px solid rgb(128, 128, 128);
  padding: 1rem;
  text-align: center;

}

.bold-text {
  font-weight: 700;
}
</style>